import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';

import {
  DELETE_API_ERROR,
  GET_ERRORS,
} from '../../store/validation.module/types';

@Component
export default class ValidatingInput extends Vue {
  @Prop(String) readonly validationContext!: string;
  @Prop(String) readonly validationPath!: string;

  get defaultValidationState() {
    return this.validateState(this.validationContext, this.validationPath);
  }

  get defaultValidationErrorMessages() {
    return this.validateErrorMessages(
      this.validationContext,
      this.validationPath,
    );
  }

  defaultClearValidation() {
    if (this.defaultValidationState === false) {
      this.clearValidation(this.validationContext, this.validationPath);
    }
  }

  validateState(context: string, path: string) {
    let err = this.$store.getters[`validation/${GET_ERRORS}`](context, path);
    return err !== undefined ? false : null;
  }

  validateErrorMessages(context: string, path: string) {
    return this.$store.getters[`validation/${GET_ERRORS}`](context, path);
  }

  clearValidation(context: string, path: string) {
    if (this.validationPath) {
      this.$store.dispatch(`validation/${DELETE_API_ERROR}`, { context, path });
    }
  }

  compoundState(errors) {
    return errors.length ? false : this.defaultValidationState;
  }

  compoundErrors(veeErrors) {
    const apiErrors = this.defaultValidationErrorMessages;
    if (Array.isArray(apiErrors)) {
      return veeErrors.concat(
        apiErrors.map((message) => {
          return this.$te(`validation.${message}`)
            ? this.$t(`validation.${message}`)
            : message;
        }),
      );
    } else {
      return veeErrors;
    }
  }

  compoundFeedback(veeErrors) {
    const allErrors = this.compoundErrors(veeErrors);
    return allErrors.length ? allErrors[0] : '';
  }
}
